<template>
 <div class="cont">
    <div class="box">
      <div class="top">海量运力，等你来找！</div>
      <div class="bottom">
        <el-form :inline="true"  class="demo-form-inline"  size="small " label-position="left">
            <el-form-item label="货物类型" prop="likeGoods" class="phhw">
             <el-select v-model="searchFrom.likeGoodsArr" multiple placeholder="请选择">
                <el-option
                  v-for="item in goodTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运输路线" prop="startArea" class="czlx">
              <el-input  placeholder="起始地" v-model="searchFrom.startArea"></el-input>
              <i class="fa fa-arrows-h" aria-hidden="true"></i>
              <el-input  placeholder="目的地" v-model="searchFrom.endArea"></el-input>
            </el-form-item>
            <el-form-item label="活跃日期:" prop="activeDates">
                <el-date-picker
                  v-model="searchFrom.activeDates"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item style="margin-top:30px ">
                <el-button type="primary" @click="searchFn">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button @click="jiluFn">找车记录</el-button>
              </el-form-item>
         </el-form>
      </div>
    </div>
 </div>
</template>

<script>
import { dropDownList } from '@/api/soc-stock'
export default {
  data () {
    return {
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        likeGoodsArr: []
      },
      goodTypes: []
    }
  },
  created () {
    dropDownList().then(res => {
      this.goodTypes = res
    })
  },
  mounted () {

  },
  methods: {
    // 查选
    searchFn () {
      this.$router.push({ name: 'SzhaoCheList', query: { from: JSON.stringify(this.searchFrom) } })
    },
    // 记录
    jiluFn () {
      this.$router.push({ name: 'SzhaoCheJilu' })
    }
  }
}
</script>

<style scoped lang='less'>
.cont{
  width: 100%;
  height: 100%;
  background: url('../../../assets/images/loginBJ.jpg') no-repeat 50%/cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .top{
    text-align: center;
    font-size: 26px;
    margin-bottom: 20px;
  }
  .bottom{
    width: 360px;
    padding: 40px 20px;
    background: #fff;
    box-shadow: 8px 16px 62px 0px rgba(108,111,115,0.75) ;
    border-radius: 6px;
    /deep/.el-form-item{
      display: flex;
      flex-direction: column;
      margin-bottom: 0px;
      margin-right: 0;
      .el-input__inner{
        height: 32px!important;
      }
    }
    .phhw /deep/.el-input__inner{
        height: 65px!important;
      }
    /deep/.el-select {
      width: 100%;
    }
    .czlx{
      /deep/.el-form-item__content{
        display: flex;
        align-items: center;
        .fa-arrows-h{
              margin: 0 4px;
        }
      }
    }
    /deep/.el-button{
      width: 100%;
      font-size: 16px;
       padding: 12px 15px;
    }
  }
}
</style>
